export class OrderFakeInvoiceModel {
    number: number|null = null
    serie: string|null = ""
    key: string|null = ""
    xml: string|null = ""
    shippingEstimateDate: Date|null = null
    shippingEstimateDays: number|null = 0
}
